module.exports = __webpack_public_path__ + "img/DIAN.a283929d.png";